import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
declare var jQuery;
import { LoginService } from './login.service';
import { Dialog, Map, Select } from '@eds/vanilla';
import * as languageConfig from '../../assets/i18n/configuration/configuration.json';
 
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit {
  alertMessage;
  dialogConsent:Dialog;
  /* For login form validation */
  @ViewChild('consentDialog') consentDialog: ElementRef;

  loginForm = new FormGroup({
    userName: new FormControl('', [Validators.required, Validators.pattern(/^[0-9a-zA-Z]+?\\[0-9a-zA-Z]+$/)]),
    passWord: new FormControl('', [Validators.required])
  });

  consentForm = new FormGroup({
    consent: new FormControl('', [Validators.required])
  });
  languageConfiguration: any;
  selectedLanguage: any;
  textDir:any;
  constructor(
    public translate: TranslateService,
    private loginService: LoginService,
    private router: Router) {
      this.languageConfiguration = (languageConfig as any).default;
      translate.addLangs([this.languageConfiguration.languages]);
      translate.setDefaultLang(this.languageConfiguration.defaultLang);
      let selectedLang = sessionStorage.getItem('selectedLang');
      let getTextDir =  sessionStorage.getItem('textDir');
      let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
      if(selectedLang){
        translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
      } else {
        const browserLang = translate.getBrowserLang();                  
        translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
        sessionStorage.setItem('selectedLang', browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);
      }      
      this.selectedLanguage = this.languageConfiguration.languageFullname[sessionStorage.getItem('selectedLang')];
      this.textDir = getTextDir;
      console.log(this.selectedLanguage);
      setTimeout(() => this.selectInit() , 100);
    }

  data = { domain: 'general', userName: '', password: '' };
  isAuthorized = false;
  showSuccessMessage = false;
  isConsented = true;
  successMessage = '';
  consent = false;
  loginSuccessResponse: any;

  ngOnInit(): void {
    this.isConsented = true;    
    let getTextDir =  sessionStorage.getItem('textDir');
    if(!getTextDir){
      this.textDir = 'ltr';
      sessionStorage.setItem('textDir',this.textDir);
    }
    
    this.successMessage = window.localStorage.getItem('resetpass');
    if (this.successMessage == null) {
      this.showSuccessMessage = false;
      window.localStorage.clear();
    }

    if (this.successMessage != null) {
      this.successMessage = window.localStorage.getItem('resetpass');
      window.localStorage.clear();
      this.showSuccessMessage = true;
    }

    this.loginForm.valueChanges.subscribe(form => {
      this.data.userName = this.loginForm.value.userName;
      this.data.password = this.loginForm.value.passWord;
     
      if (this.data.userName !== '' && this.data.password !== ''){
        this.loginForm.controls.userName.setErrors(null);
        this.loginForm.controls.passWord.setErrors(null);
      }else{
        this.loginForm.controls.userName.setErrors({incorrect: true});
        this.loginForm.controls.passWord.setErrors({incorrect: true});
      }
    });

    this.consentForm.valueChanges.subscribe(form => {
      this.consent = this.consentForm.value.consent;
      //console.log(this.consent);
      if (this.consent !== false){
        this.consentForm.controls.consent.setErrors(null);
      } else{
        this.consentForm.controls.consent.setErrors({incorrect: true});
      }
    });
    
  }

  openConsent(){
    //alert("openConsent")
    this.dialogConsent = new Dialog(this.consentDialog.nativeElement);
    this.dialogConsent.show();  
  } 
  closeConsent(){
    //alert("openConsent")
    this.dialogConsent = new Dialog(this.consentDialog.nativeElement);
    this.dialogConsent.hide();  
  } 

  selectInit(){
    const selects = document.querySelectorAll('.select');
    if (selects) {
      Array.from(selects).forEach((select1) => {
        const select = new Select(select1 as HTMLElement);
        select.init();
      });
    }
  }

  ngAfterViewInit(){
    /* this.dialogConsent = new Dialog(this.consentDialog.nativeElement);
    this.dialogConsent.init();  */
  }
 
  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bgImg');
  }
  changeToLowercase(event) {

    const str: string = event.target.value;
    this.loginForm.controls.userName.setValue(str.toLowerCase());
  }

  onClickSchoolAdmin() {
    this.loginForm.controls.userName.setValue('delhipubsch\\swatisa');
    this.loginForm.controls.passWord.setValue('ctl@123');
  }
  onClickTeacher() {
    this.loginForm.controls.userName.setValue('schone\\teach2');
    this.loginForm.controls.passWord.setValue('teach@123');
  }


  onLoginFormSubmit() {

    this.data.userName = this.loginForm.value.userName.replace(/\s/g, "");
    /* Check slashes on username */
    const n = this.data.userName.indexOf('/');
    if (n !== -1){
      this.data.userName = this.data.userName.replace('/', '\\');
    }

    this.data.password = this.loginForm.value.passWord;
    if ((this.data.userName !== '') && (this.data.password !== '')) {
      this.loginService.postLoginData(this.data).subscribe(
        (response) => {
          if (response.user){
            this.isConsented = response.consent;
            //alert(this.isConsented)
            window.localStorage.setItem('loggedInUserRole', response.user.role.desc);
            response.user.first_name = response.user.first_name.charAt(0).toUpperCase() + response.user.first_name.slice(1);
          }

          /* this function is executed every time there's a new output */
          if (response.access && response.access.token_id) {
            if (response.user.role.name === 'GeneralAdmin'){
              window.localStorage.setItem('loginInfoObj', JSON.stringify(response.user));
              window.localStorage.setItem('token', response.access.token_id);
              window.localStorage.setItem('timeout', response.access.expireIn);
              this.isConsented = true;
            }else{
              if (this.isConsented){
                window.localStorage.setItem('loginInfoObj', JSON.stringify(response.user));
                window.localStorage.setItem('token', response.access.token_id);
                window.localStorage.setItem('timeout', response.access.expireIn);
              }else{
                this.loginSuccessResponse = response;
              }
            }

            if (this.isConsented){
              this.router.navigate(['/home']);
            }

          }else {
            if (response.message === 'Login Failed! Project is inactive, Contact administrator.') {
              this.alertMessage = 'This project is now archived. For more details, please contact your administrator.';
            } else if (response.message === 'Login Failed! School is inactive, Contact administrator.'){
              this.alertMessage = 'This school is now archived. For more details, please contact your administrator.';
            } else if (response.message === 'Login Failed! Partner is inactive, Contact administrator.') {
              this.alertMessage = 'Your partner is now archived. For more details, please contact your administrator.';
            } else if (response.message === 'Login Failed! User is inactive, Contact administrator.') {
              this.alertMessage = 'This user is now archived. For more details, please contact your administrator.';
            } else if (response.message === 'Login Locked') {
              this.alertMessage = 'This account has been locked for 24 hours due to too many incorrect login attempts.';
            } 
            

            else {
              this.loginForm.controls.userName.setErrors({incorrect: true});
              this.loginForm.controls.passWord.setErrors({incorrect: true});
              this.alertMessage = 'Username or password is not recognized';
            }
          }
        },
        (err) => {
          // alert("2 " + err);
          this.alertMessage = 'Username or password is not recognized';
         // jQuery('#loginAlert').modal('show');
          // alert('Login Failed! Please provide valid Username and Password')
        },
        () => {

         // console.log("COMPLETED");
          // alert('Login Failed! Please provide valid Username and Password')
        }
      );
    } else {
      // alert('Please fill up all the fields')
      this.loginForm.controls.userName.setErrors({incorrect: true});
      this.loginForm.controls.passWord.setErrors({incorrect: true});
      this.alertMessage = 'Username or password is not recognised';
    }
    // this.router.navigate(['/landingpage']);
  }

  onConsentFormSubmit() {
    this.consent = this.consentForm.value.consent;
    const userNameArr = this.data.userName.split('\\');
    const domainName = userNameArr[0];
    const userName = userNameArr[1];
    if (this.consent){
      this.loginService.postConsentData(
        {
          username: userName,
          domain: domainName,
          token: this.loginSuccessResponse.access.token_id
        }
      ).subscribe((response) => {
        if (response.message === 'Consent added successfully'){
          window.localStorage.setItem('loginInfoObj', JSON.stringify(this.loginSuccessResponse.user));
          window.localStorage.setItem('token', this.loginSuccessResponse.access.token_id);
          window.localStorage.setItem('timeout', this.loginSuccessResponse.access.expireIn);
          this.router.navigate(['/home']);
        }
      }),
      (err) => { alert(err); },
      () => {}
    }
  }


  resetAlertMsg() {
    this.alertMessage = '';
  }
  resetSuccesstMsg(){
    this.showSuccessMessage = false;
  }
  onForgotPassword() {

    if (this.loginForm.controls['userName'].value !== '') {
      this.loginService.postForgotPasswordData(this.loginForm.controls['userName'].value).subscribe(
        (response) => {
         // alert("Password reset link sent to your email id.")
          this.alertMessage = 'Password reset link sent to your email id.';
          /* jQuery('#loginAlert').modal('show'); */
        },
        (err) => {

          console.log('ERROR: ' + err);
        },
        () => {

          console.log('COMPLETED');
        }
      );
    } else {
      this.alertMessage = 'Please provide user name';
      /* jQuery('#loginAlert').modal('show'); */
    }
  }
  setLanguage(lang, txtAlign){
    let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
    this.translate.use(lang.match(langRegExp) ? lang : 'en');  
    sessionStorage.setItem('selectedLang', lang);
    sessionStorage.setItem('textDir',txtAlign);
    this.textDir = txtAlign;
    document.documentElement.lang = lang;
  }
}
